function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.931,16.811a2.228,2.228,0,0,0-2.68-1.576l-6.42,1.744a.257.257,0,0,1-.15.01l-2.77-.426.46-.208a2.19,2.19,0,0,0,1.02-.991H19.5A2.49,2.49,0,0,0,22,12.887V2.977A2.49,2.49,0,0,0,19.5.5H4.5A2.49,2.49,0,0,0,2,2.977v9.91a2.433,2.433,0,0,0,.98,1.962L.3,16.583a.652.652,0,0,0-.19.912.668.668,0,0,0,.92.2l3.6-2.329,1.15-.743a.21.21,0,0,1,.11-.04l2.32-.535,2.97-.684a.964.964,0,0,1,1.08.536.86.86,0,0,1,.05.148.966.966,0,0,1-.52,1.12l-.42.2-1.98.932a.656.656,0,0,0,.18,1.248l4.91.744a1.532,1.532,0,0,0,.7-.04l6.41-1.734a.877.877,0,0,1,.51,1.674L14.941,20.9a.52.52,0,0,1-.17.019l-6.38-.753a1.751,1.751,0,0,0-.69.06L.491,22.212a.653.653,0,0,0-.47.8.668.668,0,0,0,.64.486,1.1,1.1,0,0,0,.18-.02L8.081,21.5a.271.271,0,0,1,.15-.02l6.38.754a1.685,1.685,0,0,0,.8-.1l7.16-2.715A2.192,2.192,0,0,0,23.931,16.811Zm-13.04-4.737-5.3,1.219a2.174,2.174,0,0,0-.54.228l-.78.505h-.01a1.162,1.162,0,0,1-.93-1.139V2.977A1.166,1.166,0,0,1,4.5,1.818h15a1.166,1.166,0,0,1,1.17,1.159v9.91a1.16,1.16,0,0,1-1.17,1.159h-5.84a1.886,1.886,0,0,0-.19-.693A2.312,2.312,0,0,0,10.891,12.074Z",
  transform: "translate(0 -0.5)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 0.75,
  cy: 0.75,
  r: 0.75,
  transform: "translate(6.77 6.682)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 0.75,
  cy: 0.75,
  r: 0.75,
  transform: "translate(11.411 6.682)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 0.75,
  cy: 0.75,
  r: 0.75,
  transform: "translate(16.051 6.682)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.002,
    height: 23,
    viewBox: "0 0 24.002 23"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/other_liabilities.f1e234c0.svg";
export { SvgComponent as ReactComponent };